const TYPES = {
    GET_GUARDIAN_INFO: 'GET_GUARDIAN_INFO',
    GET_GUARDIAN_INFO_SUCCESS: 'GET_GUARDIAN_INFO_SUCCESS',
    GET_GUARDIAN_INFO_FAILED: 'GET_GUARDIAN_INFO_FAILED',
    UPDATE_GUARDIAN_INFO: 'UPDATE_GUARDIAN_INFO',
    UPDATE_GUARDIAN_INFO_SUCCESS: 'UPDATE_GUARDIAN_INFO_SUCCESS',
    UPDATE_GUARDIAN_INFO_FAILED: 'UPDATE_GUARDIAN_INFO_FAILED'
};

export default {
    TYPES,
    getGuardianInfo: payload => {
        return {
            type: TYPES.GET_GUARDIAN_INFO,
            payload
        };
    },
    getGuardianInfoSuccess: resp => {
        return {
            type: TYPES.GET_GUARDIAN_INFO_SUCCESS,
            payload: {resp}
        };
    },
    getGuardianInfoFailed: error => {
        return {
            type: TYPES.GET_GUARDIAN_INFO_FAILED,
            payload: {error}
        };
    },
    updateGuardianInfo: payload => {
        return {
            type: TYPES.UPDATE_GUARDIAN_INFO,
            payload
        };
    },
    updateGuardianInfoSuccess: resp => {
        return {
            type: TYPES.UPDATE_GUARDIAN_INFO_SUCCESS,
            payload: {resp}
        };
    },
    updateGuardianInfoFailed: error => {
        return {
            type: TYPES.UPDATE_GUARDIAN_INFO_FAILED,
            payload: {error}
        };
    }
};
